import { useMemo } from 'react'
import useSWRInfinite from 'swr/infinite'
import { getSystemMessageList, getSystemMessageListKey } from '@/apis/letter'
import { SystemMessageListReq } from '@/types/letter'
import { uniqueByKey } from '@/utils/func'
import { useMemoizedFn } from 'ahooks'
import { useRecoilValue } from 'recoil'
import { userState } from 'Store/user'

const pageSize = 10

export function useSystemList(tab: 'System' | 'Personal' | 'Engagement') {
  const user = useRecoilValue(userState)
  const { data, error, isValidating, size, setSize, isLoading, mutate } =
    useSWRInfinite(
      user && tab === 'System'
        ? getSystemMessageListKey({ size: pageSize, platform: 'web' })
        : () => undefined,
      ({ req }: { req: SystemMessageListReq }) => getSystemMessageList(req),
      {
        keepPreviousData: true,
      }
    )

  const systemDataList = useMemo(() => {
    return uniqueByKey(
      data?.flatMap((item) => item?.list || []) || [],
      'message_id'
    )
  }, [data])
  const hasLoaded = !user || data !== undefined || error !== undefined

  const loadMore = useMemoizedFn(() => {
    if (isValidating || isLoading) return
    if (size >= 10) return
    if (systemDataList.length < (data?.flat()[0]?.total || 0)) {
      setSize((size) => size + 1).then()
    }
  })

  return {
    data: systemDataList,
    hasLoaded,
    error,
    isValidating,
    size,
    setSize,
    isLoading,
    mutate,
    loadMore,
  }
}
